module.exports = __webpack_public_path__ + "static/media/2.d28d9428.JPG";